import React from 'react';
import { Chip, Avatar as MUIAvatar, Typography, Tooltip } from '@mui/material';
import { ICourseData } from '../../types/course-data';
import Avatar from '../shared/avatar';
// import { AddToFavourites } from '../elements/favourites-button';
import { EventBus } from '@/shared/utils';
import { DashboardEvents } from '../../events';
import { LevelIconSelector } from '../../utils/select-level-icon';
import { SkilllevelsType } from 'src/shared/types/course';
import { adaptCourseTypeText } from 'src/shared/utils/adapt-course-type-text';

interface MetadataItemProps {
  label: string;
  children: React.ReactNode;
}

const MetadataItem: React.FC<MetadataItemProps> = ({ label, children }) => {
  return (
    <div className="flex flex-col gap-2 items-start w-full">
      <Typography variant="body-small-500" className="text-text-secondary" component="p">
        {label}
      </Typography>
      {children}
    </div>
  );
};

export const ModalMetadata = ({
  documentId,
  eventBus,
  videoCount,
  level,
  genres,
  duration,
  instructors,

  courseType,
  highlighted,
}: Partial<ICourseData> & {
  eventBus: EventBus<DashboardEvents>;
}) => {
  return (
    <div className="flex flex-col items-start gap-4">
      {/* <AddToFavourites documentId={documentId} eventBus={eventBus} /> */}
      {courseType !== 'Masterclass' && (
        <MetadataItem label="Lezioni">
          {videoCount !== undefined && (
            <Chip
              label={
                <Typography variant="button-s">
                  {videoCount} lezion{videoCount !== 1 ? 'i' : 'e'}
                </Typography>
              }
              size="medium"
              avatar={<MUIAvatar src="/assets/images/play-arrow-filled.png" className="mr-0" />}
              sx={{
                background: '#54566870',
              }}
            />
          )}
        </MetadataItem>
      )}
      <MetadataItem label="Livello">
        <Chip
          label={
            <Typography variant="button-s" className="ml-1">
              {level}
            </Typography>
          }
          size="small"
          avatar={
            <MUIAvatar
              src={LevelIconSelector(
                level?.toLowerCase() as SkilllevelsType,
                courseType,
                highlighted,
              )}
              sx={{ borderRadius: 0 }}
            />
          }
          sx={{
            background: '#54566870',
          }}
        />
      </MetadataItem>
      {Array.isArray(genres) && genres.length > 0 && (
        <MetadataItem label="Genere">
          <span className="space-x-2">
            {genres.map((genre, index) => (
              <Chip
                key={index}
                label={<Typography variant="button-s">{genre}</Typography>}
                size="medium"
                color="default"
                variant="outlined"
                className="self-start"
              />
            ))}
          </span>
        </MetadataItem>
      )}
      <MetadataItem label={`Durata ${courseType ? adaptCourseTypeText(courseType) : ''}`}>
        <Typography variant="caption-500" className="text-text-primary">
          {duration}
        </Typography>
      </MetadataItem>
      <MetadataItem label="Insegnante">
        <div className="flex items-center text-text-primary">
          {Array.isArray(instructors) && instructors.length > 1 ? (
            <Tooltip
              placement="top-start"
              arrow
              title={instructors.map((instructor) => instructor.name).join(', ')}
            >
              <span>
                <Avatar instructors={instructors} courseType={courseType} />
              </span>
            </Tooltip>
          ) : (
            <Avatar
              instructors={instructors as ICourseData['instructors']}
              courseType={courseType}
            />
          )}
        </div>
      </MetadataItem>
    </div>
  );
};
